import React, { useEffect, useState } from 'react';
import { FilterItem } from '@mm/state/model/AudiencesModel';
import { AudienceFilterItemInput } from '../../../../../../../common/components/AudienceFilterItemInput/AudienceFilterItemInput';
import { ConditionalLogicModeProps } from '../ConditionalLogic';
import { PrimaryButton } from '../../../../../../../common/buttons/PrimaryButton/PrimaryButton';

export const ConditionalLogicAttributeDetail = (
  props: ConditionalLogicModeProps,
) => {
  const {
    setEditMode,
    editFilter,
    setEditFilter,
    editWidget,
    setEditWidget,
    variables,
  } = props;

  const [filter, setFilter] = useState<FilterItem | undefined>();
  useEffect(() => {
    if (editFilter) {
      const matchingVariable =
        variables.find(v => v.variableId === editFilter.variableId) ||
        variables[0];
      setFilter({
        filterType: '',
        variable: matchingVariable.name,
        ...editFilter,
      });
    } else {
      setFilter({
        operator: undefined,
        value: '',
        variableId: variables[0].variableId,
        variableType: variables[0].variableType,
        filterType: '',
        variable: variables[0].name,
      });
    }
  }, [editFilter, variables]);

  const onSaveFilter = () => {
    if (!filter || !filter.operator) return;
    const updatedFilter = { ...filter, operator: filter.operator };
    let filters = editWidget.conditionalFilters || [];
    if (editFilter) {
      filters = filters.map(f => (f.id === editFilter.id ? updatedFilter : f));
    } else if (filter.operator) {
      filters = [...filters, updatedFilter];
    }
    setEditWidget({ ...editWidget, conditionalFilters: filters });
    setEditFilter(undefined);
    setEditMode('attributes');
  };

  return (
    <div className="widget-conditional-logic__sub-section">
      <div className="widget-conditional-logic__header-text">
        <PrimaryButton
          className="widget-conditional-logic__back-button"
          onClick={() => setEditMode('attributes')}
          color="gray"
        >
          <i className="fas fa-chevron-left" />
        </PrimaryButton>
        Add Attribute
      </div>
      {filter && (
        <>
          <AudienceFilterItemInput
            filter={filter}
            setFilter={setFilter}
            withEmoji
          />
          <PrimaryButton
            className="widget-conditional-logic__add-button"
            disabled={!(filter.operator && filter.value.length)}
            onClick={onSaveFilter}
          >
            Save attribute
          </PrimaryButton>
        </>
      )}
      <PrimaryButton
        color="secondary-blue"
        className="widget-conditional-logic__add-button"
        onClick={() => setEditMode('attributes')}
      >
        Cancel
      </PrimaryButton>
    </div>
  );
};
